"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require("react-router");

require("../../assets/css/components/form/ButtonFields.css");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonField = function (_React$Component) {
    _inherits(ButtonField, _React$Component);

    function ButtonField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ButtonField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonField.__proto__ || Object.getPrototypeOf(ButtonField)).call.apply(_ref, [this].concat(args))), _this), _this.getContent = function () {
            if (_this.props.content && _this.props.button !== 'fab') return _this.props.content;
            if (_this.props.button !== 'fab' && !_this.props.content) return _this.props.children;
            if (_this.props.content && _this.props.button === 'fab' && _this.props.haspopup) return _this.props.children;
        }, _this.getIcon = function () {
            if (_this.props.icon) return _react2.default.createElement(_Icone2.default, { icone: _this.props.icon, button: _this.props.button !== 'fab', tamanho: _this.props.tamanho });
        }, _this.getStyle = function (tipo, color, type) {
            var estilo = void 0;
            if (_this.props.block) estilo = "btn-block ";
            return (estilo || '') + _this.getColor(tipo, color, type) + " " + (_this.props.className || '') + (_this.props.mini ? " mdl-button--mini-fab" : "");
        }, _this.getColor = function (tipo, color, type) {
            var colorType = color || "primary";
            if (color) {
                colorType = color;
            } else if (type === 'submit') {
                colorType = "green";
            } else if (type === 'reset') {
                colorType = "red";
            } else if (type === 'button') {
                colorType = "grey";
            }
            if (tipo === 'flat') {
                return "flat-" + colorType;
            }
            return colorType;
        }, _this.redirecionar = function () {
            if (_this.props.to !== undefined && _this.props.onClick === undefined) {
                _this.props.router.push(_this.props.to || "#");
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ButtonField, [{
        key: "getIconClassName",
        value: function getIconClassName() {
            return "mdi mdi-" + this.props.icon;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var estilo = this.getStyle(this.props.button, this.props.color, this.props.type);

            return _react2.default.createElement(
                "button",
                { ref: function ref(button) {
                        return _this2.button = button;
                    }, title: this.props.title,
                    className: "mdl-js-ripple-effect mdl-button mdl-button" + (this.props.button === 'icon' ? '' : "--" + this.props.button) + " " + estilo,
                    role: this.props.role, type: this.props.type, onClick: this.props.onClick || this.redirecionar,
                    "aria-label": this.props.ariaLabel, disabled: this.props.disabled },
                this.getIcon(),
                this.getContent()
            );
        }
    }]);

    return ButtonField;
}(_react2.default.Component);

ButtonField.propTypes = {
    button: _propTypes2.default.oneOf(['raised', 'colored', 'icon', 'flat', 'fab'])
};

exports.default = (0, _reactRouter.withRouter)(ButtonField);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/ButtonFields.js
// module id = 129
// module chunks = 0